import React, { useEffect, useState } from 'react';
import cx from 'classname';
import { CloseIcon } from 'components/icons';
import Button from 'components/button';
import styles from './multi-select-modal.module.scss';
import Radio from 'components/Form/Radio';

const MultiSelectModal = ({
  onSelect,
  onClose,
  register,
  name,
  showMultiSelect,
  setShowMultiSelect,
  item,
  key,
}) => {
  const [multi, setMulti] = useState(false);

  const handleSave = () => {
    setShowMultiSelect(false);
  };

  useEffect(() => {
    setMulti(item.allowMultiSelect);
  }, [item]);

  return (
    <div className={showMultiSelect ? styles.block : styles.hide}>
      <div className={cx(styles.backgroundWrapper, styles.display_block)}>
        <div className={styles.container}>
          <div className={styles.container__header}>
            <h3>Configure Category</h3>
            <CloseIcon onClick={onClose} />
          </div>

          <div className={styles.container__body}>
            <h5>Select if this is a single or multiple choice category</h5>
            <div className={styles.container__body__inputs}>
              <div className={styles.container__body__inputs__item}>
                <Radio
                  id={key}
                  name={name}
                  isSelected={multi === false}
                  changed={() => {
                    onSelect(false);
                    setMulti(false);
                  }}
                  testId="radio one"
                  ref={register({
                    required: false,
                  })}
                  defaultValue={!multi}
                >
                  Single Choice
                </Radio>
              </div>
              <div className={styles.container__body__inputs__item}>
                <Radio
                  id={key}
                  name={name}
                  isSelected={multi === true}
                  changed={() => {
                    onSelect(true);
                    setMulti(true);
                  }}
                  testId="radio one"
                  ref={register({
                    required: false,
                  })}
                  defaultValue={multi}
                >
                  Multiple Choice
                </Radio>
              </div>
            </div>
          </div>
          <div className={styles.container__btn}>
            <Button
              variant="primary"
              text="Save Changes"
              onClick={handleSave}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultiSelectModal;
